import { useSyncExternalStore } from "react";

export type Route =
  | { name: "library"; folderId: string | null }
  | { name: "trash" }
  | { name: "editor"; id: string };

function parse(path: string): Route {
  let m = /^\/d\/([\w-]+)\/?$/.exec(path);
  if (m) return { name: "editor", id: m[1]! };
  m = /^\/f\/([\w-]+)\/?$/.exec(path);
  if (m) return { name: "library", folderId: m[1]! };
  if (/^\/trash\/?$/.test(path)) return { name: "trash" };
  return { name: "library", folderId: null };
}

export const folderPath = (folderId: string | null) => (folderId ? `/f/${folderId}` : "/");

const listeners = new Set<() => void>();
let current = parse(location.pathname);
window.addEventListener("popstate", () => {
  current = parse(location.pathname);
  listeners.forEach((l) => l());
});

export function navigate(path: string, opts: { replace?: boolean } = {}) {
  if (path === location.pathname) return;
  if (opts.replace) history.replaceState(null, "", path);
  else history.pushState(null, "", path);
  current = parse(path);
  listeners.forEach((l) => l());
}

export function useRoute(): Route {
  return useSyncExternalStore(
    (fn) => {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
    () => current,
  );
}
